import React, { useRef, useState } from 'react'
import styles from './styles.module.scss'
import { useTranslation } from 'react-i18next'
import PureSettings from '../PureSettings.jsx'
import Button from 'srcReact/components/common2/Button'
import { useDispatch } from 'react-redux'
import { createUpdateGroupActions } from '../../actions'

function GroupType({
  nextSectionVisible,
  containerCss,
  innerContainerCss,
  verticalLineCss,
  infoCss,
  show,
  hideNextButton,
  titleCss,
  editMode,
  buttonWrapperCss,
  workplaces,
  selectedWorkplace,
  isGeneralGroup,
  loggedInUser
}) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const containerRef = useRef(null)
  const [selectedType, setSelectedType] = useState('interest')

  const handleTypeChange = (value) => {
    setSelectedType(value)
    dispatch(createUpdateGroupActions.setGroupType(value))
  }

  const handleNext = () => {
    dispatch(createUpdateGroupActions.setGroupType(selectedType))
    dispatch(createUpdateGroupActions.showGroupName())
  }
  console.log('show::', show)
  return (
    <div
      id='groupTypeContainer'
      ref={containerRef}
      className={`${containerCss} ${!nextSectionVisible && !editMode && styles.container} ${
        workplaces && workplaces.length === 1 ? styles.subContainer : ''
      } ${show ? styles.show : styles.hide}`}>
      {!editMode && (
        <React.Fragment>
          <div class={verticalLineCss} />
          {selectedWorkplace &&
            (isGeneralGroup ? (
              <p className={`${infoCss} ${styles.innerPara}`}>
                {t('group.createGeneralGroup.groupName.title1', {
                  workplace: selectedWorkplace ? selectedWorkplace.name : '',
                  name: loggedInUser ? loggedInUser.firstname : ''
                })}
              </p>
            ) : (
              <p className={infoCss}>
                {t('group.createGroup.groupType.title1', {
                  workplace: selectedWorkplace.name
                })}
              </p>
            ))}
        </React.Fragment>
      )}
      <div className={`${innerContainerCss} ${styles.innerContainer}`}>
        <PureSettings
          show={true}
          title={t('group.createGroup.groupType.title2')}
          className={styles.container}
          iconSize='large32'
          aboutClassName={styles.about}
          settings={[
            {
              key: 'interest',
              text: t('group.createGroup.groupType.interest.title'),
              value: 'interest',
              iconName: 'heart',

              aboutText: t('group.createGroup.groupType.interest.desc'),
              isSelected: selectedType === 'interest'
            },
            {
              key: 'expertise',
              text: t('group.createGroup.groupType.expertise.title'),
              value: 'expertise',
              iconName: 'star-solid',
              aboutText: t('group.createGroup.groupType.expertise.desc'),
              isSelected: selectedType === 'expertise'
            }
          ]}
          handleChange={handleTypeChange}
        />
        {!hideNextButton && (
          <div className={buttonWrapperCss}>
            <Button type='button' handleClick={handleNext} text={t('group.createGroup.btnNext')} />
          </div>
        )}
      </div>
    </div>
  )
}

export default GroupType
